import React from 'react';
import SettingsPageTemplate from '../SettingsPageTemplate';
import TeamListContainer from './TeamListContainer';

export default () => (
  <SettingsPageTemplate>
    <TeamListContainer />
  </SettingsPageTemplate>
);
